let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dLvDd")).then(() => parcelRequire('bFIyM'));